var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14653_125963)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.0556,
    cy: 3.72222,
    r: 2.72222,
    fill: "#C8CFC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 7.99995C1 7.57039 1.34822 7.22217 1.77778 7.22217H10.3333C10.7629 7.22217 11.1111 7.57039 11.1111 7.99995V10.3333C11.1111 12.9106 9.02177 14.9999 6.44445 14.9999H5.66667C3.08934 14.9999 1 12.9106 1 10.3333V7.99995Z",
    fill: "#C8CFC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14653_125963"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/Avatar.478a80baca63975bded8a425440cf869.svg";
export { ForwardRef as ReactComponent };